"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var FloatingCTA = /** @class */ (function (_super) {
    __extends(FloatingCTA, _super);
    function FloatingCTA() {
        var _this = _super.call(this, constants_1.DATA_FLOATING_CTA) || this;
        if (!_this.getElement())
            return _this;
        _this.floatingCTA = document.querySelector("[".concat(constants_1.DATA_FLOATING_CTA, "]"));
        // Temporary fix for duplicate contact element flags
        var flags = document.querySelectorAll("[".concat(constants_1.DATA_FLOATING_CTA, "]"));
        if (flags.length > 0) {
            for (var i = 1; i < flags.length; i++) {
                flags[i].style.display = 'none';
            }
        }
        _this.documentScroll();
        window.addEventListener('scroll', function () {
            _this.hideContactFloat();
        });
        if (_this.floatingCTA && document.querySelector("[".concat(constants_1.DATA_FLOATING_LINK, "]"))) {
            document.querySelector("[".concat(constants_1.DATA_FLOATING_LINK, "]")).classList.add('is-hidden');
        }
        return _this;
    }
    FloatingCTA.prototype.documentScroll = function () {
        var _this = this;
        document.addEventListener('scroll', function () {
            if (window.scrollY > 10) {
                _this.floatingCTA.classList.add(constantsClasses_1.CLASS_SCROLLED);
            }
            else {
                _this.floatingCTA.classList.remove(constantsClasses_1.CLASS_SCROLLED);
            }
        });
    };
    FloatingCTA.prototype.hideContactFloat = function () {
        this.floatingContactButton = document.querySelector('[data-floating-cta]');
        this.floatingContactElement = document.querySelector('[data-contact-element]');
        if (this.contactFloatIsInViewport(this.floatingContactElement)) {
            this.floatingContactButton.classList.add('is-hidden');
        }
        else if (this.floatingContactButton) {
            this.floatingContactButton.classList.remove('is-hidden');
        }
    };
    FloatingCTA.prototype.contactFloatIsInViewport = function (elem) {
        if (this.floatingContactButton) {
            var rect = elem.getBoundingClientRect();
            return (rect.top <= ((window.innerHeight || document.documentElement.clientHeight)));
        }
    };
    return FloatingCTA;
}(AbstractComponent_1.default));
exports.default = FloatingCTA;
